<mat-nav-list class="width-100">
  <ng-container *ngFor="let module of modules; index as i">
    <a
      mat-list-item
      [disableRipple]="true"
      #navLinks
      class="comp-info-link"
      [href]="getNavLink(module)">
      <h2 class="font-regular font-sm">{{ module[0].title | titlecase }}</h2>
    </a>
  </ng-container>

  <a
    mat-list-item
    [disableRipple]="true"
    class="comp-info-link"
    [href]="getNavLink(null, 'custom', 'entries')"
    #entryLink>
    <h2 class="font-regular font-sm">Entries</h2>
  </a>

  <a
    mat-list-item
    [disableRipple]="true"
    class="comp-info-link"
    *ngIf="!competition.discussion_url"
    (click)="getNavLink(null, 'custom', 'discussions')"
    #discussionLink>
    <h2 class="font-regular font-sm">Discussions</h2>
  </a>

  <a
    mat-list-item
    [disableRipple]="true"
    class="comp-info-link"
    *ngIf="competition.discussion_url"
    [href]="competition.discussion_url"
    target="_blank"
    #discussionLink>
    <h2 class="font-regular font-sm">Discussions</h2>
  </a>
</mat-nav-list>
